import { NgSelectModule } from '@ng-select/ng-select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { NgProgressModule } from 'ngx-progressbar';
import { NgbModule, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

import { ProductDetailComponent } from './productdetail/product.detail.component';
import { ProductService } from '../services/product.service';
import { EventListenerService } from '../services/close-listenenr.service';
import { SharedModule } from '../shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { NgxPaginationModule } from 'ngx-pagination';
import { OptionsFilterPipe } from '../shared/pipes/options.pipe';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { ModalPopupModule } from '../shared/modal-popup/modal-popup.module';



const routes: Routes = [
    {
        path: 'productdetail/:sku',
        component: ProductDetailComponent,
    },
    {
        path: 'product/productdetail/:sku',
        component: ProductDetailComponent,
    }
];

@NgModule({
    imports: [
        CommonModule,
        NgProgressModule,
        FormsModule,
        RouterModule.forChild(routes),
        NgbModule,
        SharedModule,
        MatSelectModule,
        NgxPaginationModule,
        MatSortModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        NgSelectModule,
        ChildHeaderModule,
        ModalPopupModule
    ],
    providers: [ProductService, EventListenerService, NgbCarouselConfig],
    declarations: [ProductDetailComponent, OptionsFilterPipe, ],
    exports: [ProductDetailComponent, ]
})

export class ProductDetailModule {
    constructor(config: NgbCarouselConfig) {
        // customize default values of carousels used by this component tree
        config.interval = 10000;
        config.wrap = false;
        config.keyboard = false;
    }
}
